import { GuidEmpty } from 'mbs-ui-kit/utils/constants';
import { ScheduleStepValue } from 'mbs-ui-shared@models/backup/schedule-models';
import { BackupToRestoreStepValue } from 'wizards/models/backup-to-restore-models';
import { Storages } from 'wizards/models/base/base-models/plan-storages-model';
import { DestinationStepValue } from 'wizards/models/destination-models';
import { EncryptionOptionsStepValue } from 'wizards/models/encryption-options-models';
import { NotificationsStepValue } from 'wizards/models/notifications-models';
import { PlanNameStepValue } from 'wizards/models/plan-name-models';
import { PrePostActionsStepValue } from 'wizards/models/pre-post-actions-models';
import { RestoreDisksStepValue } from 'wizards/models/restore-disks-models';
import { RestorePointStepValue } from 'wizards/models/restore-point-models';
import { ScheduleAdvancedStepValue, ScheduleFormSettings } from 'wizards/models/schedule-advanced-models';
import { SelectHostStepValue } from 'wizards/models/select-host-models';
import { VirtualDisksSelectedType } from 'wizards/models/select-virtual-disks-models';
import { ComputerToRestoreStepValue } from 'wizards/models/selected-computers-models';
import { WhereBackupStepValue } from 'wizards/models/where-backup-models';

export const FileFormatsForRestoreType = [
  'Hyper-V Virtual Disk (VHD-format) fixed',
  'Hyper-V Virtual Disk (VHD-format) dynamic',
  'RAW disk image raw',
  'RAW disk image rawsparse',
  'RAW disk image tar',
  'RAW disk image tgz',
  'VMware Virtual Disk vmfsfixed',
  'VMware Virtual Disk vmfsdynamic',
  'Hyper-V Virtual Disk (VHDX-format) dynamic',
  'VirtualBox Virtual Disk fixed',
  'VirtualBox Virtual Disk dynamic'
];

export class BaseRestoreFormsModel {
  planNameStep: PlanNameStepValue = { Name: '', SavePlanInCloud: false, valid: true };
  whereBackupStep: WhereBackupStepValue = { IsHybridBackup: false, HybridID: GuidEmpty, ConnectionID: GuidEmpty, valid: false };
  computerToRestoreStep: ComputerToRestoreStepValue = { computerName: '', isCurrent: true, valid: false };
  backupToRestoreStep: BackupToRestoreStepValue;
  restorePointStep: RestorePointStepValue = {
    restoreType: 0,
    fromDateTime: { date: '', time: '' },
    toDateTime: { date: '', time: '' },
    valid: true
  };
  Storages: Storages = { CloudStorages: [], LocalStorages: [] };
  fileFormats: string[] = FileFormatsForRestoreType;

  restoreDisksStep: RestoreDisksStepValue = { type: VirtualDisksSelectedType.All, folders: [], excludes: [], valid: true };

  destinationStep: DestinationStepValue = {
    destinationFolder: '',
    virtualImageName: '',
    overwriteExistingFiles: false,
    valid: true
  };
  encryptionOptionsStep: EncryptionOptionsStepValue = {
    password: '',
    valid: true
  };
  scheduleStep: ScheduleStepValue = {
    ScheduleType: 'noschedule',
    specificDateGroup: { date: new Date(), time: '00:00:00' },
    StopAfterEnabled: false,
    stopAfterHours: 0,
    stopAfterMinutes: 0,
    ForceMissedSchedule: false,
    overdueAfterSuccessEnabled: false,
    overdueAfterSuccessAmount: 7,
    overdueAfterSuccessPeriod: 1,
    syncBeforeRun: false,
    valid: true
  };
  scheduleAdvancedStep: ScheduleAdvancedStepValue = {
    forceFull: new ScheduleFormSettings(),
    blockLevel: new ScheduleFormSettings(),
    scheduleDiff: new ScheduleFormSettings(null, null),
    scheduleTLog: new ScheduleFormSettings(null, null),
    valid: true
  };
  prePostActionsStep: PrePostActionsStepValue = {
    executeCommandBeforeBackup: false,
    preAction: '',
    exitOnPreActionFail: true,
    executeCommandAfterBackupCompletion: false,
    postAction: '',
    executePostActionOnSuccess: true,
    valid: true
  };
  notificationStep: NotificationsStepValue = {
    receiveNotificationOnCompleteGroup: { flag: true, case: 'whenFails' },
    valid: true
  };

  selectHostStep?: SelectHostStepValue;

  constructor(public isNBF = false) {
    if (isNBF) this.backupToRestoreStep = { selectedBunch: '', valid: false };
  }
}
